export default "__VITE_ASSET__Dzl7dla2__";